module.exports = __webpack_public_path__ + "static/media/content_rating_n.2acf6315.svg";